import { httpRequest } from "@/lib/axios";
import { Employee, EmployeeResponse } from "@/types";
import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

async function fetchEmployees(
  page?: string | null,
  per_page?: number | null,
  status?: string | null,
  search?: string | null,
  positionsId?: string | null
): Promise<EmployeeResponse> {
  const pageParams = !per_page
    ? `page=${page || 1}`
    : `page=${page || 1}&per_page=${per_page || ""}&status=${
        status || ""
      }&roleId=${positionsId || ""}&search=${search || ""}`;
  const employees = await httpRequest.get<EmployeeResponse>(
    `/employees?${pageParams}`
  );
  return employees.data;
}

async function fetchEmployeesNoPaginate(): Promise<AxiosResponse<Employee[]>> {
  return await httpRequest.get<Employee[]>("/list/employees");
}

export function useFetchEmployeesQuery({
  page,
  per_page,
  status,
  search,
  positionsId,
}: {
  page?: string | null;
  per_page?: number | null;
  status?: string | null;
  search?: string | null;
  positionsId?: string | null;
}) {
  const employeesQuery = useQuery({
    queryKey: ["employees", page || "1", per_page, status, search, positionsId],
    queryFn: () => fetchEmployees(page, per_page, status, search, positionsId),
    keepPreviousData: true,
    enabled: true,
  });
  return {
    ...employeesQuery,
    data: employeesQuery.data,
  };
}

export function useFetchEmployeesNoPaginateQuery() {
  const employeesQuery = useQuery({
    queryKey: ["employees"],
    queryFn: fetchEmployeesNoPaginate,
    // keepPreviousData: true,
    enabled: true,
  });

  return {
    ...employeesQuery,
    data: employeesQuery.data?.data,
  };
}
